import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

export function ResetAuthToken() {
  let route = '/login';
  if (this.globalDataService.loginType !== null) {
    if (this.globalDataService.loginType === 'skyswitch') {
      route = '/pbx' + route;
    }
  }
  this.globalDataService.DeleteCookies();
  this.router.navigate([route]);
}

export function IsAdmin() {
   return (this.globalDataService.role === '2' || this.globalDataService.role === '3');
}

@Injectable()
export class GlobalDataService {

  public DeleteCookies(){
    this.cookieService.deleteAll('/');
  }


  get token(): string {
    return this.cookieService.get('token');
  }
  set token(value: string) {
    this.cookieService.set('token', value, null, '/', null, true, "None");
  }

  get refreshToken(): string {
    return this.cookieService.get('refreshToken');
  }

  set refreshToken(value: string) {
    this.cookieService.set('refreshToken', value, null, '/', null, true, "None");
  }

  get loginType(): string {
    return this.cookieService.get('loginType');
  }

  set loginType(value: string) {
    this.cookieService.set('loginType', value, null, '/', null, true, "None");
  }

  get role(): string {
    return this.cookieService.get('role');
  }
  set role(value: string) {
    this.cookieService.set('role', value, null, '/', null, true, "None");
  }

  get skyLogin(): string {
    return this.cookieService.get('skyLogin');
  }

  set skyLogin(value: string) {
    this.cookieService.set('skyLogin', value, null, '/', null, true, "None");
  }

  constructor(private cookieService: CookieService) {
  }

}



// WEBPACK FOOTER //
// ./src/app/global-data.service.ts